module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_img2.d0c9b2ce.png";